module.exports = __webpack_public_path__ + "media/aba_darach.62907ec0.mp3";